import React from "react";
import useAuth from "../hooks/useAuth.js";
import Navbar from "./Navbar.js";
import CallToAction from "./CallToAction.js";
import Footer from "./Footer.js";

function AccessibilityPolicy() {
const { isAuthenticated } = useAuth();

  return (
    <section id="Privacypagepage">
      <Navbar isAuthenticated={isAuthenticated} />

      <div className="container-fluid text-white  pl-16 py-5 page-header mb-5">
        <h1 className="text-3xl font-bold mb-4">Accessibility Policy</h1>

        <p className="text-sm mb-2">Effective Date: 29/11/2025</p>
        <p className="text-sm ">Last Updated: 29/11/2025</p>
    </div>
    
    <div className="max-w-3xl mx-auto p-4 md:p-6 lg:p-8">
      <h2 className="text-2xl font-bold mb-2">1. Commitment to Accessibility</h2>
      <p className="text-sm text-gray-600 mb-4">
        Our goal is to make the Ajo App accessible and inclusive by:
      </p>
      <ul className="list-disc pl-4 mb-4">
        <li className="text-sm text-gray-600 mb-2">
          Complying with the Web Content Accessibility Guidelines (WCAG) 2.1 at Level AA.
        </li>
        <li className="text-sm text-gray-600 mb-2">
          Designing our app to be usable with assistive technologies such as screen readers, voice recognition software, and other accessibility tools.
        </li>
        <li className="text-sm text-gray-600 mb-2">
          Regularly reviewing and improving our platform to meet evolving accessibility needs.
        </li>
      </ul>

      <h2 className="text-2xl font-bold mb-2">2. Features Supporting Accessibility</h2>
      <p className="text-sm text-gray-600 mb-4">
        To ensure accessibility, the Ajo App includes the following features:
      </p>
      <ul className="list-disc pl-4 mb-4">
        <li className="text-sm text-gray-600 mb-2">
          Keyboard Navigation:
        </li>
        <ul className="list-disc pl-4 mb-4">
          <li className="text-sm text-gray-600 mb-2">
            Full functionality is available using only a keyboard.
          </li>
        </ul>
        <li className="text-sm text-gray-600 mb-2">
          Screen Reader Compatibility:
        </li>
        <ul className="list-disc pl-4 mb-4">
          <li className="text-sm text-gray-600 mb-2">
            All app elements, including forms and buttons, are labeled for screen reader usage.
          </li>
        </ul>
        <li className="text-sm text-gray-600 mb-2">
          Text Alternatives:
        </li>
        <ul className="list-disc pl-4 mb-4">
          <li className="text-sm text-gray-600 mb-2">
            Images and non-text content include descriptive alt text.
          </li>
        </ul>
        <li className="text-sm text-gray-600 mb-2">
          Scalable Text:
        </li>
        <ul className="list-disc pl-4 mb-4">
          <li className="text-sm text-gray-600 mb-2">
            Users can adjust text sizes for readability without loss of functionality.
          </li>
        </ul>
        <li className="text-sm text-gray-600 mb-2">
          High Contrast Mode:
        </li>
        <ul className="list-disc pl-4 mb-4">
          <li className="text-sm text-gray-600 mb-2">
            An optional high-contrast mode is available for better visibility.
          </li>
        </ul>
        <li className="text-sm text-gray-600 mb-2">
          Captioned Media:
        </li>
        <ul className="list-disc pl-4 mb-4">
          <li className="text-sm text-gray-600 mb-2">
            Videos and audio content include captions or transcripts where applicable.
          </li>
        </ul>
      </ul>

      <h2 className="text-2xl font-bold mb-2">3. How We Maintain Accessibility</h2>
      <p className="text-sm text-gray-600 mb-4">
        We actively maintain and enhance accessibility through:
      </p>
      <ul className="list-disc pl-4 mb-4">
        <li className="text-sm text-gray-600 mb-2">
          Testing:
        </li>
        <ul className="list-disc pl-4 mb-4">
          <li className="text-sm text-gray-600 mb-2">
            Regular audits using automated tools and manual checks for WCAG compliance.
          </li>
        </ul>
        <li className="text-sm text-gray-600 mb-2">
          Feedback:
        </li>
        <ul className="list-disc pl-4 mb-4">
          <li className="text-sm text-gray-600 mb-2">
            Encouraging users to report accessibility barriers and acting promptly on feedback.
          </li>
        </ul>
        <li className="text-sm text-gray-600 mb-2">
          Training:
        </li>
        <ul className="list-disc pl-4 mb-4">
          <li className="text-sm text-gray-600 mb-2">
            Providing training for our development team on accessible design and development practices.
          </li>
        </ul>
        <li className="text-sm text-gray-600 mb-2">
          Updates:
        </li>
        <ul className="list-disc pl-4 mb-4">
          <li className="text-sm text-gray-600 mb-2">
            Incorporating accessibility improvements during app updates.
          </li>
        </ul>
      </ul>

      <h2 className="text-2xl font-bold mb-2">4. Third-Party Services</h2>
      <p className="text-sm text-gray-600 mb-4">
        While we strive to ensure full accessibility, some features of Ajo App may rely on third-party services (e.g., Stripe). We work closely with these providers to ensure accessibility compliance wherever possible.
      </p>

      <h2 className="text-2xl font-bold mb-2">5. Reporting Accessibility Issues</h2>
      <p className="text-sm text-gray-600 mb-4">
        If you encounter any accessibility barriers while using the Ajo App, please contact us. We will address your concerns promptly and take steps to improve accessibility.
      </p>
      <p className="text-sm text-gray-600 mb-4">
        Contact Information:
      </p>
      <ul className="list-disc pl-4 mb-4">
        <li className="text-sm text-gray-600 mb-2">
          Email: <a href="mailto:accessibility@ajoapp.ca" className="text-blue-600 hover:text-blue-800">accessibility@ajoapp.ca</a>
        </li>
        <li className="text-sm text-gray-600 mb-2">
          In-App Support: Use the "Help" section of the app to report issues.
        </li>
      </ul>

      <h2 className="text-2xl font-bold mb-2">6. Continuous Improvement</h2>
      <p className="text-sm text-gray-600 mb-4">
        Accessibility is an ongoing effort. We are committed to:
      </p>
      <ul className="list-disc pl-4 mb-4">
        <li className="text-sm text-gray-600 mb-2">
          Regularly updating our platform to improve accessibility.
        </li>
        <li className="text-sm text-gray-600 mb-2">
          Collaborating with accessibility experts to implement best practices.
        </li>
        <li className="text-sm text-gray-600 mb-2">
          Soliciting feedback from users with disabilities to better understand their needs.
        </li>
      </ul>

      <h2 className="text-2xl font-bold mb-2">7. Compliance</h2>
      <p className="text-sm text-gray-600 mb-4">
        This Accessibility Policy aligns with:
      </p>
      <ul className="list-disc pl-4 mb-4">
        <li className="text-sm text-gray-600 mb-2">
          Web Content Accessibility Guidelines (WCAG) 2.1, Level AA
        </li>
        <li className="text-sm text-gray-600 mb-2">
          Accessibility for Ontarians with Disabilities Act (AODA) (if applicable in Canada)
        </li>
        <li className="text-sm text-gray-600 mb-2">
          Other applicable local accessibility laws and regulations.
        </li>
      </ul>

      <h2 className="text-2xl font-bold mb-2">8. Feedback and Suggestions</h2>
      <p className="text-sm text-gray-600 mb-4">
        We value your input on how we can improve accessibility. If you have suggestions, please let us know via the contact methods provided above.
      </p>

      <p className="text-sm text-gray-600 mb-4">
        At Ajo App, inclusivity is a core value. We are dedicated to ensuring that everyone, regardless of ability, can access and benefit from our platform.
      </p>

    </div>
      <CallToAction />
      <Footer />
    </section>
  );
}

export default AccessibilityPolicy;
